export default __webpack_public_path__ + "static/media/learn-more-card-2.7c7a935a.svg";